import linkifyHtml from 'components/text_editor_new/lib/linkify_html';
import serializeHtmlExternal from 'components/text_editor_new/lib/serialize_html_external';

// Serializes the email body and turns any bare URLs into <a> links.
export default function serializeEmailBody(editor) {
  return linkifyHtml(serializeHtmlExternal(editor));
}
